import React from 'react'
import { string, func, bool } from 'prop-types'
import { Form, TextInput } from '@cobalt/cobalt-react-components'
import {
  EMAIL,
  EMAIL_PLACEHOLDER,
  EMAIL_VALIDATION_MESSAGE
} from '../../constants/ui.labels'

const PasswordResetForm = ({
  onEmailValidation,
  email,
  onEmailChange,
  disabledForm
}) => {
  return (
    <React.Fragment>
      <Form.Field
        label={EMAIL}
        onValidate={onEmailValidation}
        validationMessages={{
          custom: EMAIL_VALIDATION_MESSAGE
        }}
        disabled={disabledForm}
      >
        <TextInput
          placeholder={EMAIL_PLACEHOLDER}
          type={TextInput.TYPE_EMAIL}
          autoFocus
          onChange={onEmailChange}
          value={email}
        />
      </Form.Field>
    </React.Fragment>
  )
}

PasswordResetForm.propTypes = {
  onEmailValidation: func.isRequired,
  email: string.isRequired,
  onEmailChange: func.isRequired,
  disabledForm: bool.isRequired
}

PasswordResetForm.defaultProps = {
  disabledForm: false
}

export default PasswordResetForm
